import { Button, Container, Header, Icon, Segment } from '@mairistem/composants';
import React from 'react';
import { useHistory } from 'react-router';

import { baseUrlFront } from '@/routes';

const AucunPointageMessage = () => {
  const history = useHistory();

  const handleRedirectToBordereaux = React.useCallback(() => {
    history.push(`${baseUrlFront}/versements-remises/bordereaux-remise`);
  }, [history]);

  return (
    <Container fluid>
      <Segment basic textAlign="center">
        <Header size="large" data-testid="prelevement-inactif-message">
          <Header.Content>
            <Icon name="check square" color="green" />
            Pointage terminé
            <br />
            <br />
            <Header.Subheader>
              Tous les règlements sur la période en cours ont été pointés et liés à un bordereau de
              remise.
              <br />
              <br />
              Vous pouvez consulter la liste des bordereaux générés en cliquant sur le bouton
              ci-dessous.
              <br />
            </Header.Subheader>
          </Header.Content>
        </Header>
        <br />
        <Button
          data-testid="redirect-to-bordereaux-button"
          onClick={handleRedirectToBordereaux}
          className="domain-colored"
        >
          Accéder aux bordereaux de remise
        </Button>
      </Segment>
    </Container>
  );
};

export default AucunPointageMessage;
